import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "./style.css";
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>ENT Endoscopy Cost in Delhi | Advanced Treatment & Surgery</title>
            <meta name="description" content="Find safe and effective Nasal Endoscopy in Delhi, India. Explore diagnostic and treatment procedures with expert ENT doctors at leading clinics." />
            <meta name="keywords" content="ENT endoscopy Delhi, nasal endoscopy, throat endoscopy, Endoscopy cost,Is endoscopy painful,Endoscopy near me,Endoscopy procedure,Endoscopy test,Endoscopy price" />
            <link rel="canonical" href="https://entdelhi.com/endoscopy/" />
            <meta property="og:title" content="ENT Endoscopy Cost in Delhi | Advanced Treatment & Surgery" />
            <meta property="og:description" content="Find safe and effective Nasal Endoscopy in Delhi, India. Explore diagnostic and treatment procedures with expert ENT doctors at leading clinics." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
